import { render, staticRenderFns } from "./AlignBottomIcon.vue?vue&type=template&id=3050396a&"
import script from "./AlignBottomIcon.vue?vue&type=script&lang=js&"
export * from "./AlignBottomIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports